import React from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { LocaleService } from '@sm360/widget-commons-core-services';
import { PurchaseMethods } from '@sm360/widget-commons-vehicle';

import PurchaseMethodsTabControlContainer from 'payment-calculator/components/PaymentCalculatorDetails/components/PurchaseMethodsTabControl/PurchaseMethodsTabControlContainer.jsx';

import * as Actions from 'payment-calculator/actions/paymentCalculatorActions.js';

import 'payment-calculator/components/PaymentCalculatorDetails/PaymentCalculatorDetails.scss';

const PaymentCalculatorDetails = (props) => {
    return (
        <div className="showroom-calculator-new">
            <PurchaseMethodsTabControlContainer
                cashPurchaseSelected={props.purchaseMethods.cashPurchase.selected}
                displayCreditRate={props.displayCreditRate}
                freightLabel={props.freightLabel}
            />
            <div className="calculator-done sr-paymentCalculator-Panelbackground">
                {
                    // TODO: #Will be activated later
                    // <button onClick={props.closePanel} className="sr-link">
                    //     { LocaleService.t('PAYMENT_CALCULATOR.CANCELTITLE') }
                    // </button>
                }
                <button onClick={props.closePanel} className="sr-button-1 is-small">
                    {LocaleService.t('PAYMENT_CALCULATOR.DONETITLE')}
                </button>
            </div>
        </div>
    );
};
PaymentCalculatorDetails.defaultProps = {
    displayCreditRate: false,
    freightLabel: '',
};
PaymentCalculatorDetails.propTypes = {
    purchaseMethods: PropTypes.instanceOf(PurchaseMethods.PurchaseMethodsModel),
    closePanel: PropTypes.func.isRequired,
    displayCreditRate: PropTypes.bool,
    freightLabel: PropTypes.string,
};

PaymentCalculatorDetails.displayName = 'PaymentCalculatorDetails';

function mapStateToProps(state) {
    return {
        purchaseMethods: state.purchaseMethods,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(PaymentCalculatorDetails);
export { PaymentCalculatorDetails };
